import { Quill } from "react-quill-new";
import { registerNoteLink } from "../components/editor/noteLinkFormat";

// Registers the note-link format on the app's Quill once, at import, before
// any editor mounts (editors whitelist "notelink" in their formats).
registerNoteLink(Quill);
